export type Level = 'low' | 'medium' | 'high';
export const levelNames = ['high', 'medium', 'low'];
export const levelTranslate = {
    high: 'COMMON.HIGH',
    medium: 'HAMSTA.MEDIUM',
    low: 'COMMON.LOW',
};

export const particle = { step: 1, min: 5, max: 10 };

interface Rows {
    [key: string]: number[];
}
interface LevelsInterface {
    [key: string]: {
        [key: string]: {
            [key: string]: number[];
        };
    };
}

const levels: LevelsInterface = {
    97: {
        low: {
            8: [5.7, 2.2, 1.1, 1, 0.4, 1, 1.1, 2.2, 5.7],
            9: [6, 2.8, 1.6, 1, 0.6, 0.6, 1, 1.6, 2.8, 6],
            10: [10, 3, 1.6, 1.1, 0.9, 0.5, 0.9, 1.1, 1.6, 3, 10],
            11: [11, 2.9, 1.8, 1.2, 1, 0.7, 0.7, 1, 1.2, 1.8, 2.9, 11],
            12: [12, 3.2, 1.6, 1.4, 1.1, 1, 0.4, 1, 1.1, 1.4, 1.6, 3.2, 12],
            13: [15, 7, 3.2, 2, 1.2, 0.9, 0.6, 0.6, 0.9, 1.2, 2, 3.2, 7, 15],
            14: [
                18, 5.2, 2.3, 1.6, 1.3, 1.1, 0.9, 0.5, 0.9, 1.1, 1.3, 1.6, 2.3,
                5.2, 18,
            ],
            15: [
                20, 9, 4, 2.1, 1.6, 1.1, 1, 0.6, 0.6, 1, 1.1, 1.6, 2.1, 4, 9,
                20,
            ],
            16: [
                22, 10, 5, 1.6, 1.4, 1.2, 1.1, 0.9, 0.5, 0.9, 1.1, 1.2, 1.4,
                1.6, 5, 10, 22,
            ],
        },
        medium: {
            8: [13, 3.8, 1.3, 0.6, 0.3, 0.6, 1.3, 3.8, 13],
            9: [21, 4, 1.8, 0.9, 0.4, 0.4, 0.9, 1.8, 4, 21],
            10: [24, 5, 2, 1.3, 0.6, 0.4, 0.6, 1.3, 2, 5, 24],
            11: [33, 6, 3, 1.9, 0.7, 0.4, 0.4, 0.7, 1.9, 3, 6, 33],
            12: [38, 12, 4.3, 2, 1.1, 0.5, 0.3, 0.5, 1.1, 2, 4.3, 12, 38],
            13: [45, 15, 6.2, 3, 1.3, 0.6, 0.4, 0.4, 0.6, 1.3, 3, 6.2, 15, 45],
            14: [80, 16, 7, 4, 2, 1, 0.4, 0.2, 0.4, 1, 2, 4, 7, 16, 80],
            15: [
                90, 22, 12, 5, 3, 1.3, 0.4, 0.3, 0.3, 0.4, 1.3, 3, 5, 12, 22,
                90,
            ],
            16: [
                120, 56, 12, 5, 3, 1.5, 1, 0.4, 0.3, 0.4, 1, 1.5, 3, 5, 12, 56,
                120,
            ],
        },
        high: {
            8: [26, 4, 1.5, 0.3, 0.2, 0.3, 1.5, 4, 26],
            9: [44, 6.3, 2, 0.6, 0.2, 0.2, 0.6, 2, 6.3, 44],
            10: [77, 10, 3, 0.8, 0.3, 0.2, 0.3, 0.8, 3, 10, 77],
            11: [125, 14, 5, 1.3, 0.4, 0.2, 0.2, 0.4, 1.3, 5, 14, 125],
            12: [172, 24, 8.1, 2, 0.7, 0.2, 0.1, 0.2, 0.7, 2, 8.1, 24, 172],
            13: [280, 36, 12, 4, 1, 0.2, 0.1, 0.1, 0.2, 1, 4, 12, 36, 280],
            14: [
                425, 56, 18, 5, 1.9, 0.3, 0.2, 0.1, 0.2, 0.3, 1.9, 5, 18, 56,
                425,
            ],
            15: [
                640, 84, 27, 8, 3.2, 0.5, 0.2, 0.1, 0.1, 0.2, 0.5, 3.2, 8, 27,
                84, 640,
            ],
            16: [
                1000, 128, 26, 9, 4, 2, 0.2, 0.2, 0.1, 0.2, 0.2, 2, 4, 9, 26,
                128, 1000,
            ],
        },
    },
    92: {
        low: {
            8: [5.41, 2.09, 1.04, 0.95, 0.38, 0.95, 1.04, 2.09, 5.41],
            9: [5.69, 2.66, 1.52, 0.95, 0.57, 0.57, 0.95, 1.52, 2.66, 5.69],
            10: [
                9.48, 2.85, 1.52, 1.04, 0.85, 0.47, 0.85, 1.04, 1.52, 2.85,
                9.48,
            ],
            11: [
                10.43, 2.75, 1.71, 1.14, 0.95, 0.66, 0.66, 0.95, 1.14, 1.71,
                2.75, 10.43,
            ],
            12: [
                11.38, 3.04, 1.52, 1.33, 1.04, 0.95, 0.38, 0.95, 1.04, 1.33,
                1.52, 3.04, 11.38,
            ],
            13: [
                14.23, 6.64, 3.04, 1.9, 1.14, 0.85, 0.57, 0.57, 0.85, 1.14, 1.9,
                3.04, 6.64, 14.23,
            ],
            14: [
                17.07, 4.93, 2.18, 1.52, 1.23, 1.04, 0.85, 0.47, 0.85, 1.04,
                1.23, 1.52, 2.18, 4.93, 17.07,
            ],
            15: [
                18.97, 8.54, 3.79, 1.99, 1.52, 1.04, 0.95, 0.57, 0.57, 0.95,
                1.04, 1.52, 1.99, 3.79, 8.54, 18.97,
            ],
            16: [
                20.87, 9.48, 4.74, 1.52, 1.33, 1.14, 1.04, 0.85, 0.47, 0.85,
                1.04, 1.14, 1.33, 1.52, 4.74, 9.48, 20.87,
            ],
        },
        medium: {
            8: [12.33, 3.6, 1.23, 0.57, 0.28, 0.57, 1.23, 3.6, 12.33],
            9: [19.92, 3.79, 1.71, 0.85, 0.38, 0.38, 0.85, 1.71, 3.79, 19.92],
            10: [
                22.76, 4.74, 1.9, 1.23, 0.57, 0.38, 0.57, 1.23, 1.9, 4.74,
                22.76,
            ],
            11: [
                31.3, 5.69, 2.85, 1.8, 0.66, 0.38, 0.38, 0.66, 1.8, 2.85, 5.69,
                31.3,
            ],
            12: [
                36.04, 11.38, 4.08, 1.9, 1.04, 0.47, 0.28, 0.47, 1.04, 1.9,
                4.08, 11.38, 36.04,
            ],
            13: [
                42.68, 14.23, 5.88, 2.85, 1.23, 0.57, 0.38, 0.38, 0.57, 1.23,
                2.85, 5.88, 14.23, 42.68,
            ],
            14: [
                75.88, 15.18, 6.64, 3.79, 1.9, 0.95, 0.38, 0.19, 0.38, 0.95,
                1.9, 3.79, 6.64, 15.18, 75.88,
            ],
            15: [
                85.36, 20.87, 11.38, 4.74, 2.85, 1.23, 0.38, 0.28, 0.28, 0.38,
                1.23, 2.85, 4.74, 11.38, 20.87, 85.36,
            ],
            16: [
                113.81, 53.11, 11.38, 4.74, 2.85, 1.42, 0.95, 0.38, 0.28, 0.38,
                0.95, 1.42, 2.85, 4.74, 11.38, 53.11, 113.81,
            ],
        },
        high: {
            8: [24.66, 3.79, 1.42, 0.28, 0.19, 0.28, 1.42, 3.79, 24.66],
            9: [41.73, 5.98, 1.9, 0.57, 0.19, 0.19, 0.57, 1.9, 5.98, 41.73],
            10: [
                73.03, 9.48, 2.85, 0.76, 0.28, 0.19, 0.28, 0.76, 2.85, 9.48,
                73.03,
            ],
            11: [
                118.56, 13.28, 4.74, 1.23, 0.38, 0.19, 0.19, 0.38, 1.23, 4.74,
                13.28, 118.56,
            ],
            12: [
                163.13, 22.76, 7.68, 1.9, 0.66, 0.19, 0.09, 0.19, 0.66, 1.9,
                7.68, 22.76, 163.13,
            ],
            13: [
                265.57, 34.14, 11.38, 3.79, 0.95, 0.19, 0.09, 0.09, 0.19, 0.95,
                3.79, 11.38, 34.14, 265.57,
            ],
            14: [
                403.09, 53.11, 17.07, 4.74, 1.8, 0.28, 0.19, 0.09, 0.19, 0.28,
                1.8, 4.74, 17.07, 53.11, 403.09,
            ],
            15: [
                607.01, 79.67, 25.61, 7.59, 3.04, 0.47, 0.19, 0.09, 0.09, 0.19,
                0.47, 3.04, 7.59, 25.61, 79.67, 607.01,
            ],
            16: [
                948.45, 121.4, 24.66, 8.54, 3.79, 1.9, 0.19, 0.19, 0.09, 0.19,
                0.19, 1.9, 3.79, 8.54, 24.66, 121.4, 948.45,
            ],
        },
    },
    65: {
        low: {
            8: [3.82, 1.47, 0.74, 0.67, 0.27, 0.67, 0.74, 1.47, 3.82],
            9: [4.02, 1.88, 1.07, 0.67, 0.4, 0.4, 0.67, 1.07, 1.88, 4.02],
            10: [6.7, 2.01, 1.07, 0.74, 0.6, 0.34, 0.6, 0.74, 1.07, 2.01, 6.7],
            11: [
                7.37, 1.94, 1.21, 0.8, 0.67, 0.47, 0.47, 0.67, 0.8, 1.21, 1.94,
                7.37,
            ],
            12: [
                8.04, 2.14, 1.07, 0.94, 0.74, 0.67, 0.27, 0.67, 0.74, 0.94,
                1.07, 2.14, 8.04,
            ],
            13: [
                10.05, 4.69, 2.14, 1.34, 0.8, 0.6, 0.4, 0.4, 0.6, 0.8, 1.34,
                2.14, 4.69, 10.05,
            ],
            14: [
                12.06, 3.48, 1.54, 1.07, 0.87, 0.74, 0.6, 0.34, 0.6, 0.74, 0.87,
                1.07, 1.54, 3.48, 12.06,
            ],
            15: [
                13.4, 6.03, 2.68, 1.41, 1.07, 0.74, 0.67, 0.4, 0.4, 0.67, 0.74,
                1.07, 1.41, 2.68, 6.03, 13.4,
            ],
            16: [
                14.74, 6.7, 3.35, 1.07, 0.94, 0.8, 0.74, 0.6, 0.34, 0.6, 0.74,
                0.8, 0.94, 1.07, 3.35, 6.7, 14.74,
            ],
        },
        medium: {
            8: [8.71, 2.55, 0.87, 0.4, 0.2, 0.4, 0.87, 2.55, 8.71],
            9: [14.07, 2.68, 1.21, 0.6, 0.27, 0.27, 0.6, 1.21, 2.68, 14.07],
            10: [
                16.08, 3.35, 1.34, 0.87, 0.4, 0.27, 0.4, 0.87, 1.34, 3.35,
                16.08,
            ],
            11: [
                22.11, 4.02, 2.01, 1.27, 0.47, 0.27, 0.27, 0.47, 1.27, 2.01,
                4.02, 22.11,
            ],
            12: [
                25.46, 8.04, 2.88, 1.34, 0.74, 0.34, 0.2, 0.34, 0.74, 1.34,
                2.88, 8.04, 25.46,
            ],
            13: [
                30.15, 10.05, 4.15, 2.01, 0.87, 0.4, 0.27, 0.27, 0.4, 0.87,
                2.01, 4.15, 10.05, 30.15,
            ],
            14: [
                53.61, 10.72, 4.69, 2.68, 1.34, 0.67, 0.27, 0.13, 0.27, 0.67,
                1.34, 2.68, 4.69, 10.72, 53.61,
            ],
            15: [
                60.31, 14.74, 8.04, 3.35, 2.01, 0.87, 0.27, 0.2, 0.2, 0.27,
                0.87, 2.01, 3.35, 8.04, 14.74, 60.31,
            ],
            16: [
                80.41, 37.53, 8.04, 3.35, 2.01, 1.01, 0.67, 0.27, 0.2, 0.27,
                0.67, 1.01, 2.01, 3.35, 8.04, 37.53, 80.41,
            ],
        },
        high: {
            8: [17.42, 2.68, 1.01, 0.2, 0.13, 0.2, 1.01, 2.68, 17.42],
            9: [29.48, 4.22, 1.34, 0.4, 0.13, 0.13, 0.4, 1.34, 4.22, 29.48],
            10: [51.6, 6.7, 2.01, 0.54, 0.2, 0.13, 0.2, 0.54, 2.01, 6.7, 51.6],
            11: [
                83.76, 9.38, 3.35, 0.87, 0.27, 0.13, 0.13, 0.27, 0.87, 3.35,
                9.38, 83.76,
            ],
            12: [
                115.26, 16.08, 5.43, 1.34, 0.47, 0.13, 0.07, 0.13, 0.47, 1.34,
                5.43, 16.08, 115.26,
            ],
            13: [
                187.63, 24.12, 8.04, 2.68, 0.67, 0.13, 0.07, 0.07, 0.13, 0.67,
                2.68, 8.04, 24.12, 187.63,
            ],
            14: [
                284.79, 37.53, 12.06, 3.35, 1.27, 0.2, 0.13, 0.07, 0.13, 0.2,
                1.27, 3.35, 12.06, 37.53, 284.79,
            ],
            15: [
                428.87, 56.29, 18.09, 5.36, 2.14, 0.34, 0.13, 0.07, 0.07, 0.13,
                0.34, 2.14, 5.36, 18.09, 56.29, 428.87,
            ],
            16: [
                670.1, 85.77, 17.42, 6.03, 2.68, 1.34, 0.13, 0.13, 0.07, 0.13,
                0.13, 1.34, 2.68, 6.03, 17.42, 85.77, 670.1,
            ],
        },
    },
    62.5:{
        low: {
            8: [3.67, 1.42, 0.71, 0.64, 0.26, 0.64, 0.71, 1.42, 3.67],
            9: [3.87, 1.81, 1.05, 0.64, 0.38, 0.38, 0.64, 1.05, 1.81, 3.87],
            10: [6.44, 1.93, 1.03, 0.71, 0.58, 0.32, 0.58, 0.71, 1.03, 1.93, 6.44],
            11: [7.07, 1.87, 1.15, 0.78, 0.64, 0.45, 0.45, 0.64, 0.78, 1.15, 1.87, 7.07],
            12: [7.72, 2.06, 1.03, 0.9, 0.71, 0.64, 0.26, 0.64, 0.71, 0.9, 1.03, 2.06, 7.72],
            13: [9.65, 4.5, 2.07, 1.29, 0.78, 0.58, 0.38, 0.38, 0.58, 0.78, 1.29, 2.07, 4.5, 9.65],
            14: [11.58, 3.35, 1.48, 1.03, 0.83, 0.71, 0.58, 0.32, 0.58, 0.71, 0.83, 1.03, 1.48, 3.35, 11.58],
            15: [12.86, 5.8, 2.57, 1.35, 1.04, 0.72, 0.64, 0.38, 0.38, 0.64, 0.72, 1.04, 1.35, 2.57, 5.8, 12.86],
            16: [14.15, 6.44, 3.21, 1.03, 0.9, 0.77, 0.71, 0.58, 0.32, 0.58, 0.71, 0.77, 0.9, 1.03, 3.21, 6.44, 14.15]
        },
        medium: {
            8: [8.36, 2.44, 0.85, 0.38, 0.2, 0.38, 0.85, 2.44, 8.36],
            9: [13.51, 2.58, 1.15, 0.58, 0.26, 0.26, 0.58, 1.15, 2.58, 13.51],
            10: [15.44, 3.21, 1.29, 0.84, 0.38, 0.26, 0.38, 0.84, 1.29, 3.21, 15.44],
            11: [21.23, 3.83, 1.93, 1.23, 0.45, 0.26, 0.26, 0.45, 1.23, 1.93, 3.83, 21.23],
            12: [24.45, 7.72, 2.77, 1.29, 0.71, 0.32, 0.2, 0.32, 0.71, 1.29, 2.77, 7.72, 24.45],
            13: [28.95, 9.65, 4, 1.93, 0.84, 0.38, 0.26, 0.26, 0.38, 0.84, 1.93, 4, 9.65, 28.95],
            14: [51.46, 10.3, 4.5, 2.59, 1.29, 0.64, 0.26, 0.12, 0.26, 0.64, 1.29, 2.59, 4.5, 10.3, 51.46],
            15: [57.9, 14.14, 7.72, 3.21, 1.92, 0.83, 0.26, 0.2, 0.2, 0.26, 0.83, 1.92, 3.21, 7.72, 14.14, 57.9],
            16: [77.2, 36.02, 7.72, 3.21, 1.92, 0.97, 0.64, 0.26, 0.2, 0.26, 0.64, 0.97, 1.92, 3.21, 7.72, 36.02, 77.2]
        },
        high: {
            8: [16.72, 2.57, 0.97, 0.2, 0.12, 0.2, 0.97, 2.57, 16.72],
            9: [28.31, 4.07, 1.31, 0.39, 0.12, 0.12, 0.39, 1.31, 4.07, 28.31],
            10: [49.54, 6.44, 1.93, 0.51, 0.2, 0.12, 0.2, 0.51, 1.93, 6.44, 49.54],
            11: [80.41, 9.01, 3.21, 0.86, 0.26, 0.12, 0.12, 0.26, 0.86, 3.21, 9.01, 80.41],
            12: [110.65, 15.44, 5.23, 1.3, 0.47, 0.12, 0.06, 0.12, 0.47, 1.3, 5.23, 15.44, 110.65],
            13: [180.13, 23.16, 7.73, 2.58, 0.66, 0.12, 0.06, 0.06, 0.12, 0.66, 2.58, 7.73, 23.16, 180.13],
            14: [273.41, 36.03, 11.6, 3.21, 1.24, 0.2, 0.12, 0.06, 0.12, 0.2, 1.24, 3.21, 11.6, 36.03, 273.41],
            15: [411.72, 54.04, 17.37, 5.15, 2.08, 0.32, 0.13, 0.06, 0.06, 0.13, 0.32, 2.08, 5.15, 17.37, 54.04, 411.72],
            16: [643.3, 82.35, 16.72, 5.79, 2.58, 1.3, 0.14, 0.12, 0.06, 0.12, 0.14, 1.3, 2.58, 5.79, 16.72, 82.35, 643.3]
        }
    },
    60: {
        low: {
            8: [3.53, 1.36, 0.68, 0.62, 0.25, 0.62, 0.68, 1.36, 3.53],
            9: [3.71, 1.73, 0.99, 0.62, 0.37, 0.37, 0.62, 0.99, 1.73, 3.71],
            10: [
                6.19, 1.86, 0.99, 0.68, 0.56, 0.31, 0.56, 0.68, 0.99, 1.86,
                6.19,
            ],
            11: [
                6.8, 1.79, 1.11, 0.74, 0.62, 0.43, 0.43, 0.62, 0.74, 1.11, 1.79,
                6.8,
            ],
            12: [
                7.42, 1.98, 0.99, 0.87, 0.68, 0.62, 0.25, 0.62, 0.68, 0.87,
                0.99, 1.98, 7.42,
            ],
            13: [
                9.28, 4.33, 1.98, 1.24, 0.74, 0.56, 0.37, 0.37, 0.56, 0.74,
                1.24, 1.98, 4.33, 9.28,
            ],
            14: [
                11.13, 3.22, 1.42, 0.99, 0.8, 0.68, 0.56, 0.31, 0.56, 0.68, 0.8,
                0.99, 1.42, 3.22, 11.13,
            ],
            15: [
                12.37, 5.57, 2.47, 1.3, 0.99, 0.68, 0.62, 0.37, 0.37, 0.62,
                0.68, 0.99, 1.3, 2.47, 5.57, 12.37,
            ],
            16: [
                13.61, 6.19, 3.09, 0.99, 0.87, 0.74, 0.68, 0.56, 0.31, 0.56,
                0.68, 0.74, 0.87, 0.99, 3.09, 6.19, 13.61,
            ],
        },
        medium: {
            8: [8.04, 2.35, 0.8, 0.37, 0.19, 0.37, 0.8, 2.35, 8.04],
            9: [12.99, 2.47, 1.11, 0.56, 0.25, 0.25, 0.56, 1.11, 2.47, 12.99],
            10: [
                14.85, 3.09, 1.24, 0.8, 0.37, 0.25, 0.37, 0.8, 1.24, 3.09,
                14.85,
            ],
            11: [
                20.41, 3.71, 1.86, 1.18, 0.43, 0.25, 0.25, 0.43, 1.18, 1.86,
                3.71, 20.41,
            ],
            12: [
                23.51, 7.42, 2.66, 1.24, 0.68, 0.31, 0.19, 0.31, 0.68, 1.24,
                2.66, 7.42, 23.51,
            ],
            13: [
                27.84, 9.28, 3.84, 1.86, 0.8, 0.37, 0.25, 0.25, 0.37, 0.8, 1.86,
                3.84, 9.28, 27.84,
            ],
            14: [
                49.48, 9.9, 4.33, 2.47, 1.24, 0.62, 0.25, 0.12, 0.25, 0.62,
                1.24, 2.47, 4.33, 9.9, 49.48,
            ],
            15: [
                55.67, 13.61, 7.42, 3.09, 1.86, 0.8, 0.25, 0.19, 0.19, 0.25,
                0.8, 1.86, 3.09, 7.42, 13.61, 55.67,
            ],
            16: [
                74.23, 34.64, 7.42, 3.09, 1.86, 0.93, 0.62, 0.25, 0.19, 0.25,
                0.62, 0.93, 1.86, 3.09, 7.42, 34.64, 74.23,
            ],
        },
        high: {
            8: [16.08, 2.47, 0.93, 0.19, 0.12, 0.19, 0.93, 2.47, 16.08],
            9: [27.22, 3.9, 1.24, 0.37, 0.12, 0.12, 0.37, 1.24, 3.9, 27.22],
            10: [
                47.63, 6.19, 1.86, 0.49, 0.19, 0.12, 0.19, 0.49, 1.86, 6.19,
                47.63,
            ],
            11: [
                77.32, 8.66, 3.09, 0.8, 0.25, 0.12, 0.12, 0.25, 0.8, 3.09, 8.66,
                77.32,
            ],
            12: [
                106.39, 14.85, 5.01, 1.24, 0.43, 0.12, 0.06, 0.12, 0.43, 1.24,
                5.01, 14.85, 106.39,
            ],
            13: [
                173.2, 22.27, 7.42, 2.47, 0.62, 0.12, 0.06, 0.06, 0.12, 0.62,
                2.47, 7.42, 22.27, 173.2,
            ],
            14: [
                262.89, 34.64, 11.13, 3.09, 1.18, 0.19, 0.12, 0.06, 0.12, 0.19,
                1.18, 3.09, 11.13, 34.64, 262.89,
            ],
            15: [
                395.88, 51.96, 16.7, 4.95, 1.98, 0.31, 0.12, 0.06, 0.06, 0.12,
                0.31, 1.98, 4.95, 16.7, 51.96, 395.88,
            ],
            16: [
                618.56, 79.18, 16.08, 5.57, 2.47, 1.24, 0.12, 0.12, 0.06, 0.12,
                0.12, 1.24, 2.47, 5.57, 16.08, 79.18, 618.56,
            ],
        },
    },
};

export default levels;
